// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Carousel:after,.Carousel:before{content:\"\";height:100%;position:absolute;top:0;width:1.25rem;z-index:2}.Carousel:before{background-image:linear-gradient(270deg,hsla(0,0%,100%,.001) 0,#fff);left:0}.Carousel:after{background-image:linear-gradient(90deg,hsla(0,0%,100%,.001) 0,#fff);right:0}.Carousel__wrapper{padding:1.25rem 0}.Carousel__control{z-index:3}.Carousel__controlIconWrapper{box-shadow:0 .25rem .25rem 0 rgba(26,26,26,.09)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
